import type { ReactNode } from "react";

/**
 * Shared helpers of the payload detail renderers. FieldRow is for a detail
 * panel, not a data table, so BaseEditableTable does not apply and no raw
 * table element is used.
 */
export function FieldRow({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <div>
      <span className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
        {label}
      </span>
      <div className="mt-1">{children}</div>
    </div>
  );
}

export function readString(
  source: Record<string, unknown> | undefined,
  key: string,
): string | undefined {
  const value = source?.[key];
  return typeof value === "string" && value.trim() ? value : undefined;
}

export const DATE_PREFIX = /^\d{4}-\d{2}-\d{2}/;

/** The org-local clock time (HH:mm) of an RFC 3339 string, read from the text so the browser zone cannot shift it. */
export function clockTime(value: string | undefined): string | undefined {
  return value && value.length >= 16 && value[10] === "T"
    ? value.slice(11, 16)
    : undefined;
}
